import { Chip, Grid } from "@mui/material";

// ----------------------------------------------------------------------

type Props = {
	entities: string[];
	filtersSelected: string[];
	onSelectFilter: (filter: string) => void;
};

export default function TableFilterEntity({ entities, filtersSelected, onSelectFilter }: Props) {
	return (
		<Grid container sx={{ px: 3, mb: 2 }} spacing={2}>
			{entities.map((row, index) => (
				<Grid item key={index}>
					<Chip
						size='small'
						onClick={() => onSelectFilter(row)}
						label={row}
						color={filtersSelected.find((i) => i === row) ? "primary" : "default"}
					/>
				</Grid>
			))}
		</Grid>
	);
}
